import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { LoggedInGuard } from './logged-in.guard';

@Injectable({
  providedIn: 'root',
})
export class PotentialCustomerGuard extends LoggedInGuard {
  public override checkUrlAllowed(url: string): Observable<boolean> {
    return super.checkUrlAllowed(url).pipe(switchMap(() => this.authService.isPotentialCustomer()));
  }
}
